(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Habitto v19: al tocar una muestra de la tarjeta, cambian el nombre del color y el precio */
  (function () {
    if (window.__habittoCardSwatches) return;
    window.__habittoCardSwatches = true;

    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.name || input.name.slice(-7) !== '-swatch') return;

        var card = input.closest('product-card');
        if (!card) return;

        var value = input.value;
        var label = card.querySelector('[data-habitto-card-color]');
        if (label) label.textContent = value;

        var map = card.querySelector('script[data-habitto-prices]');
        if (!map) return;
        try {
          var price = JSON.parse(map.textContent)[value];
          if (!price) return;
          card.querySelectorAll('product-price .price').forEach(function (el) {
            el.textContent = price;
          });
        } catch (e) {}
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
